<div
  class="d-md-flex justify-content-between align-items-baseline mb-4 mt-4"
  [class.detract-attention]="!orderVolume"
  data-zid="volume-container"
>
  <div class="zero-text p-bigger-reg">{{ 'trade.create.volume.label' | transloco }}</div>
  <div class="value" [class.text-color-error]="isBuyingPowerTooLow">
    {{ orderVolume | currency }}
    @if (isBuy && buyingPowerDetails) {
      <trade-create-buying-power [buyingPowerDetails]="buyingPowerDetails" [isBuyingPowerTooLow]="isBuyingPowerTooLow" />
    }
  </div>
</div>
@if (isBuyingPowerTooLow) {
  <div class="d-flex justify-content-center text-color-error mb-4">{{ 'trade.create.volume.buyingPowerTooLow' | transloco }}</div>
}
